import { ContentLayout } from 'layout';
import { DossierTextContainer } from 'pods/dossier/text';
import React from 'react';
export const DossierTextScene = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ContentLayout, null,
            React.createElement(DossierTextContainer, null))));
};
